//import * as bootstrap from 'bootstrap'

//import Alert from '../../../node_modules/bootstrap/js/src/alert'
//import Button from '../../../node_modules/bootstrap/js/src/button'
import Carousel from '../../../node_modules/bootstrap/js/src/carousel'
import Collapse from '../../../node_modules/bootstrap/js/src/collapse'
//import Dropdown from '../../../node_modules/bootstrap/js/src/dropdown'
import Modal from '../../../node_modules/bootstrap/js/src/modal'
//import Offcanvas from '../../../node_modules/bootstrap/js/src/offcanvas'
//import Popover from '../../../node_modules/bootstrap/js/src/popover'
//import ScrollSpy from '../../../node_modules/bootstrap/js/src/scrollspy'
//import Tab from '../../../node_modules/bootstrap/js/src/tab'
//import Toast from '../../../node_modules/bootstrap/js/src/toast'
//import Tooltip from '../../../node_modules/bootstrap/js/src/tooltip'

import Filtering from "./components/Filtering"

function preloadSlideAndNeighbors(carouselEl, index) {
    if (!carouselEl) return;
    const items = carouselEl.querySelectorAll('.carousel-item');
    const total = items.length;
    if (total === 0) return;

    const indices = [
        index,
        (index - 1 + total) % total,
        (index + 1) % total
    ];

    for (const idx of indices) {
        const img = items[idx]?.querySelector('img[loading="lazy"]');
        if (img) {
            img.loading = 'eager';
        }
    }
}

document.addEventListener('show.bs.modal', (e) => {
    const modal = e.target;
    if (!modal || !modal.classList.contains('galleryElement--modal')) return;
    const carouselEl = modal.querySelector('.carousel');
    if (!carouselEl) return;
    const items = Array.from(carouselEl.querySelectorAll('.carousel-item'));
    const activeIdx = Math.max(0, items.findIndex((el) => el.classList.contains('active')));
    preloadSlideAndNeighbors(carouselEl, activeIdx);
});

document.addEventListener('slide.bs.carousel', (e) => {
    const carouselEl = e.target;
    if (!carouselEl || !carouselEl.closest('.galleryElement--modal')) return;
    if (typeof e.to === 'number') {
        preloadSlideAndNeighbors(carouselEl, e.to);
    }
});

document.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    const openModal = document.querySelector('.galleryElement--modal.show');
    if (!openModal) return;
    const carouselEl = openModal.querySelector('.carousel');
    if (!carouselEl) return;
    const carousel = Carousel.getOrCreateInstance(carouselEl);
    e.preventDefault();
    if (e.key === 'ArrowLeft') {
        carousel.prev();
    } else {
        carousel.next();
    }
});

export default {
//    Alert,
//    Button,
    Carousel,
    Collapse,
//    Dropdown,
    Modal,
//    Offcanvas,
//    Popover,
//    ScrollSpy,
//    Tab,
//    Toast,
//    Tooltip,
    Filtering
}
